import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const linkQnsToSurveyAction = createAsyncThunk(
    'link-qns-survey',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/link-qns-survey`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const linkQnsToSurveySlice = createSlice({
    name: 'link-qns-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(linkQnsToSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(linkQnsToSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(linkQnsToSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const linkQnsToSurveyReducer = linkQnsToSurveySlice.reducer    